import axios from "./axios";

export default {
  namespaced: true,

  state: {
    addresses: [],
    address: []
  },
  getters: {
    gAddresses(state) {
      return state.addresses
    },
    gAddress(state) {
      return state.address
    }
  },
  actions: {
    aSearch({ commit, rootGetters, rootState }, value) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          
          axios.get('profile/find-gp/' + value)
            .then(response => {
              if (response.data.data) {
                commit('mSearch', response.data.data)
                resolve(true)
              } else {
                reject(false)
              }
            })
            .catch(error => {
              reject(error.response.data)
            })
        })
      }
    },
    aGetGp({ commit, rootGetters, rootState }) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.put('profile/getgp/' + rootGetters['user/gCurrentProfile'])
            .then(response => {
              if (response.data.status) {
                commit('mUpdate', response.data.data)
                console.log(response.data.data)
                resolve(true)
              } else {
                reject(false)
              }
            })
            .catch(error => {
              reject(error.response.data)
            })
        })
      }
    },
    aUpdate({ commit, rootGetters, rootState }, value) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.put('profile/setgp/' + rootGetters['user/gCurrentProfile'], JSON.stringify(value))
            .then(response => {
              if (response.data.status) {
                commit('mUpdate', response.data.data)
                resolve(true)
              } else {
                reject(false)
              }
            })
            .catch(error => {
              reject(error.response.data)
            })
        })
      }
    }
    
  },
  mutations: {
    mSearch(state, result) {
      return state.addresses = result;
    },
    mUpdate(state, value) {
      state.address = value.gp
    }

  }

}